
import * as defaultImport from "@splunk/react-ui/Menu";
export * from "@splunk/react-ui/Menu";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
